module.exports = __webpack_public_path__ + "static/media/plus.1e15e405.svg";